import { registerPlugin } from '@capacitor/core';

export interface CastPlugin {
  isAvailable(): Promise<{ available: boolean }>;
  isConnected(): Promise<{ connected: boolean }>;
  requestSession(): Promise<void>;
  showCastDialog(): Promise<void>;
  loadMedia(options: {
    url: string;
    title?: string;
    artist?: string;
    imageUrl?: string;
  }): Promise<void>;
  stopCasting(): Promise<void>;
  addListener(
    eventName: 'sessionStarted' | 'sessionEnded' | 'sessionResumed' | 'sessionSuspended',
    listenerFunc: () => void,
  ): Promise<any>;
}

const Cast = registerPlugin<CastPlugin>('CastPlugin');

export default Cast; 